import { Grid } from "@mui/material";
import ReusableButton from "../../components/general/ReusableButton";

export default function SectionSubmitRow({
  disabled,
  submitting,
  onSubmit,
  margin,
}) {
  return (
    <Grid
      container
      justifyContent="flex-end"
      style={{
        margin: margin ? margin : "16px 40px 24px",
      }}
    >
      <ReusableButton
        text="Submit"
        bgColor="#5E75C3"
        fontSize={16}
        onClick={onSubmit}
        disabledButton={disabled || submitting}
      />
    </Grid>
  );
}
